import { useSelector } from "react-redux";

const selector = (state) => state.insights.publishInsight.lang;

export const useCurrentInsightLang = () => {
  return useSelector(selector);
};
